import { render, staticRenderFns } from "./ArchivedPlaybookNotes.vue?vue&type=template&id=081aaead&scoped=true&"
import script from "./ArchivedPlaybookNotes.vue?vue&type=script&lang=js&"
export * from "./ArchivedPlaybookNotes.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedPlaybookNotes.vue?vue&type=style&index=0&id=081aaead&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081aaead",
  null
  
)

export default component.exports